import { FeatureFlagOptions } from 'config/featureFlags';
import { useFlags } from 'flagsmith/react';

export default function useCASTFlags<FF extends FeatureFlagOptions[]>(flags: FF) {
  return useFlags<FF[number]>(flags);
}
